/* eslint-disable @typescript-eslint/naming-convention */
import { Camera } from '@ionic-native/camera/ngx';
import { File } from '@ionic-native/file/ngx';
import { Network } from '@ionic-native/network/ngx';
import { FileTransfer } from '@ionic-native/file-transfer/ngx';
// import { OneSignal } from '@ionic-native/onesignal/ngx';
import { Toast } from '@ionic-native/toast/ngx';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { Keyboard } from '@ionic-native/keyboard/ngx';
// import { Device } from '@ionic-native/device/ngx';
// import { Device } from '@capacitor/device';
import { DatePicker } from '@ionic-native/date-picker/ngx';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
// import { AppVersion } from '@ionic-native/app-version/ngx';
// import { AppVersion } from '@awesome-cordova-plugins/app-version'; // /app-version/ngx';
import { BatteryStatus } from '@ionic-native/battery-status/ngx';
import { OneSignal } from '@ionic-native/onesignal/ngx';
import { NavParams } from '@ionic/angular';
import { Dialogs } from '@ionic-native/dialogs/ngx';
import { Contacts } from '@ionic-native/contacts/ngx';
// import { Contacts } from '@ionic-native/contacts';
// import { NativeGeocoder, NativeGeocoderReverseResult, NativeGeocoderForwardResult  } from '@ionic-native/native-geocoder';
// import {AppRate} from '@ionic-native/app-rate';

/**
 * Created by ashok on 02/05/17.
 */
export const NativeProviders = [
  // AppVersion,
  Camera,
  File,
  Network,
  FileTransfer,
  Geolocation,
  Dialogs,
  OneSignal,
  Toast,
  Keyboard,
  // Device,
  InAppBrowser,
  DatePicker,
  StatusBar,
  SplashScreen,
  BatteryStatus,
  NavParams,
  Contacts
];
